import { render, staticRenderFns } from "./staff-select-dialog.vue?vue&type=template&id=40d48e20&"
import script from "./staff-select-dialog.vue?vue&type=script&lang=js&"
export * from "./staff-select-dialog.vue?vue&type=script&lang=js&"
import style0 from "./staff-select-dialog.vue?vue&type=style&index=0&id=40d48e20&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports